import SubHeader from "./SubHeader"

export default  SubHeader;



// WEBPACK FOOTER //
// ./src/components/App/Trips/SubHeader/index.js